import $ from 'jquery';

const $maps = $('.js_map');

const init = () => {
    if ($maps.length) {
        if (window.hasOwnProperty('ymaps')) {
            ymaps
                .ready(() => {
                    $maps.each(function() {
                        let myMap = new ymaps.Map(
                            this,
                            {
                                center: [56.067746, 92.93395],
                                zoom: 16,
                                controls: [
                                    'zoomControl',
                                    'searchControl',
                                    'typeSelector',
                                    'fullscreenControl',
                                    'trafficControl',
                                    'geolocationControl'
                                ]
                            },
                            {
                                searchControlProvider: 'yandex#search'
                            }
                        );

                        const $mapPoints = $('.js-map-item');
                        $mapPoints.each(function() {
                            try {
                                const data = JSON.parse(this.dataset.map);
                                const myPlacemarkLayout = ymaps.templateLayoutFactory.createClass(
                                    '<div class="map__placemark"></div>',
                                    {
                                        build: function() {
                                            myPlacemarkLayout.superclass.build.call(this);
                                            // При задании для метки своего HTML макета, фигуру активной области необходимо задать самостоятельно - иначе метка будет неинтерактивной. Создадим фигуру активной области "Круг".
                                            let circle = {
                                                type: 'Circle',
                                                coordinates: [6, 6],
                                                radius: 12
                                            };
                                            // Зададим фигуру активной области.
                                            this.getData().options.set('shape', circle);
                                        }
                                    }
                                );

                                let myPlaceMark = new ymaps.Placemark(
                                    [data.lat, data.lng],
                                    {
                                        balloonContent: data.title + '<br>' + data.content
                                    },
                                    {
                                        iconLayout: myPlacemarkLayout,
                                        hasBalloon: true
                                    }
                                );

                                myMap.geoObjects.add(myPlaceMark);
                            } catch (e) {
                                console.error(e);
                            }
                        });

                        myMap.behaviors.disable('scrollZoom');
                        myMap
                            .setBounds(myMap.geoObjects.getBounds(), {
                                checkZoomRange: true,
                                zoomMargin: 300
                            })
                            .catch(function(err) {
                                console.error(err);
                            });
                    });
                })
                .catch(function(err) {
                    console.error(err);
                });
        } else {
            $.getScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', init);
        }
    }
};

export default init();
